import React from "react";
import { cls } from "cls";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";

interface Props {
  price: number;
  originalPrice?: number;
  showOriginalOutletPrice?: boolean;
}

const CrossedOutPrice = ({
  price,
  originalPrice = 0,
  showOriginalOutletPrice = false,
}: Props) => (
  <>
    {showOriginalOutletPrice ? (
      <p className={cls("text-xs", "leading-snug", "mb-1")}>
        New:{" "}
        <span
          className={cls(
            "inline",
            "font-semibold",
            "text-xs",
            "leading-none",
            "m-0",
            "px-0",
            "py-3/4",
            "text-center",
            "text-gray-800",
            "uppercase",
            "line-through",
            "line-through-red-500",
          )}
        >{`${formatAsCurrency.formatIfUndefined(originalPrice)}`}</span>
      </p>
    ) : (
      <p
        className={cls(
          "block",
          "font-semibold",
          "text-base-1/2",
          "leading-none",
          "m-0",
          "px-0",
          "py-3/4",
          "text-center",
          "text-gray-800",
          "uppercase",
          "line-through",
          "line-through-red-500",
        )}
      >
        <span className="lowercase sr-only">on sale from</span>
        {` ${formatAsCurrency.formatIfUndefined(price)}`}
      </p>
    )}
  </>
);

export default CrossedOutPrice;
